<template>
  <div>
    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <b-overlay :show="isLoading" rounded="sm">
          <!--begin::Base Table Widget 7-->
          <div class="card card-custom card-stretch gutter-b">
            <!--begin::Header-->
            <div class="card-header border-0 mt-5">
              <h3 class="card-title align-items-start flex-column text-dark">
                <span class="font-weight-bolder text-dark"
                  >Liste des promotions</span
                >
              </h3>
              <div class="card-toolbar"></div>
            </div>
            <!--end::Header-->
            <!--begin::Body-->
            <div class="card-body py-0 mt-n3">
              <!--begin::Table-->
              <DxDataGrid
                @initialized="saveGridInstance"
                :data-source="dataSource"
                :remote-operations="false"
                :columns="columns"
                :show-row-lines="true"
                :word-wrap-enabled="true"
                :show-borders="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :row-alternation-enabled="false"
                :hover-state-enabled="true"
                :column-auto-width="true"
                :show-column-lines="true"
                :selection="{ mode: 'none' }"
                @row-click="onRowClick"
              >
                >
                <DxExport :enabled="true" file-name ="Promotions" />
                <DxFilterRow :visible="true" />

                <DxHeaderFilter :visible="true" :allow-search="true" />
                <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
                <DxPager
                  :show-page-size-selector="true"
                  :allowed-page-sizes="[5, 10, 20]"
                />
                <DxGroupPanel :visible="true" />
                <DxGrouping :auto-expand-all="true" />
                <DxPaging :page-size="10" />
                <DxSearchPanel :visible="true" />
                <DxSummary>
                  <DxTotalItem
                    column="startDateTimeUtc"
                    summary-type="count"
                    display-format="{0}"
                  />
                  <DxTotalItem
                    column="requestsAmount"
                    summary-type="sum"
                    :value-format="{ type: 'fixedPoint', precision: 2 }"
                    display-format="{0}"
                  />
                   <DxTotalItem
                    column="requestsCount"
                    summary-type="sum"
                    :value-format="{ type: 'fixedPoint', precision: 0 }"
                    display-format="{0}"
                  />
                </DxSummary>
              </DxDataGrid>
              <br />
              <!--end::Table-->
            </div>
            <!--end::Body-->
          </div>
          <!--end::Base Table Widget 7-->
        </b-overlay>
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
  DxExport
} from "devextreme-vue/data-grid";

import RequestsService from "../../../services/requests.service";

export default {
  name: "request-reservations",
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
    DxExport
  },
  data() {
    return {
      isLoading: false,
      dataSource: [],
      columns: [
        {
          dataField: "startDateTimeUtc",
          caption: "Date de début",
          dataType: "datetime",
        },
        {
          dataField: "endDateTimeUtc",
          caption: "Date de fin",
          dataType: "datetime",
        },
        { dataField: "name", caption: "Promotion" },
        { dataField: "code", caption: "Code" },
        {
          dataField: "requestsCount",
          caption: "Nbr d'utilisation",
          format: {
            type: "fixedPoint",
            precision: 0,
          },
        },
        {
          dataField: "requestsAmount",
          caption: "Montant",
          format: {
            type: "fixedPoint",
            precision: 2,
          },
        },
        
        // { dataField: "stateLabel", caption: "Etat" },
      ],
    };
  },
  created() {
    this.$availabilityHub.$on("request-notify", this.refresh);
  },
  beforeDestroy() {
    this.$availabilityHub.$off("request-notify", this.refresh);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Demandes", route: "promotions" },
      { title: "Promotions" },
    ]);

    // this.dataSource = createStore({
    //   key: "guid",
    //   loadUrl: `${ApiService.baseURL}coordinator/v1/requests/reservations`,
    //   onBeforeSend: DxHelper.onBeforeSend,
    //   onAjaxError: DxHelper.onAjaxError,
    // });

    this.getPromotions();
  },
  methods: {
    getPromotions: function () {
      this.isLoading = true;
      RequestsService.getPromotions().then((result) => {
        this.dataSource = result.data;
        this.isLoading = false;
      });
    },
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    onRowClick(e) {
      if (e.rowType === "data") {
        // this.$router.push({
        //   name: "requests-detail",
        //   params: { guid: e.data.guid },
        // });
      }
    },
    refresh() {
      this.getPromotions();
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
